import React from "react";

import type { CalendarFrameProps } from "./CalendarFrame.types";
import {
  CalendarBody,
  CalendarFooter,
  CalendarFooterActions,
  CalendarGrid,
  CalendarHeader,
  CalendarMeta,
  CalendarShell,
  CalendarTitle,
  CalendarWeekday,
  CalendarWeekdays,
} from "./MonthCalendar.styles";

const CalendarFrame: React.FC<CalendarFrameProps> = ({
  title,
  weekdays,
  meta,
  footer,
  footerActions,
  compact = false,
  children,
}) => (
  <CalendarShell $compact={compact}>
    <CalendarHeader $compact={compact}>
      <CalendarTitle>{title}</CalendarTitle>
      {meta ? <CalendarMeta>{meta}</CalendarMeta> : null}
    </CalendarHeader>

    <CalendarBody $compact={compact}>
      <CalendarWeekdays $compact={compact}>
        {weekdays.map((weekday) => (
          <CalendarWeekday key={weekday}>{weekday}</CalendarWeekday>
        ))}
      </CalendarWeekdays>
      <CalendarGrid $compact={compact}>{children}</CalendarGrid>
    </CalendarBody>

    <CalendarFooter $compact={compact}>
      {footer}
      {footerActions ? <CalendarFooterActions>{footerActions}</CalendarFooterActions> : null}
    </CalendarFooter>
  </CalendarShell>
);

export default CalendarFrame;
